/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './BaseCard.scss';

import classnames from 'classnames';

import React, { Fragment } from 'react';
import { arrayOf, element, oneOfType, string, bool, object } from 'prop-types';

import { Spinner } from '@trp-beacon-ui-kit/react-communication';

export default class BaseCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false
    };
  }

  openMenu = () => {
    this.setState({ showMenu: true });
  };

  closeMenu = () => {
    this.setState({ showMenu: false });
  };

  render() {
    const {
      children,
      className,
      title,
      hideMenu,
      menuOptions,
      footer,
      isLoading,
      toggle,
    } = this.props;
    const { showMenu } = this.state;
    const containerClassName =  classnames('base-card-container', className);
    return (
      <div data-testid={'base-card'} className={containerClassName}>
        {!isLoading && (
          <Fragment>
            <div className="base-card-header-container">
              {!hideMenu && menuOptions && (
                <div className="dropdown">
                  <button
                    onClick={showMenu ? this.closeMenu : this.openMenu}
                    className="menu-dropdown-button">
                    <div className="menu-dropdown-dots" />
                  </button>
                  {showMenu && (
                    <div className="dropdown-content">
                      {menuOptions.map((option, i) => {
                        return (
                          <a key={i} href={option.link}>
                            {option.label}
                          </a>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
              {title && <div className="base-card-title">{title}</div>}
              {toggle && <div className="base-card-toggle">{toggle}</div>}
            </div>
            <div className="base-card-content">
              {!isLoading && <Fragment>{children}</Fragment>}
            </div>
            {footer && (
              <div className="base-card-footer" role="contentinfo">
                {footer}
              </div>
            )}
          </Fragment>
        )}

        {isLoading && (
          <Fragment>
            {title && <div className="base-card-title">{title}</div>}
            <Spinner />
            <div className="base-card-loader-text">Gathering Data</div>
          </Fragment>
        )}
      </div>
    );
  }
}

BaseCard.defaultProps = {
  content: '',
  hideMenu: true,
  isLoading: true,
  footer: '',
  title: '',
};

BaseCard.propTypes = {
  title: oneOfType([string, element]),
  content: oneOfType([string, element]),
  footer: oneOfType([string, element]),
  menuOptions: arrayOf(object),
  hideMenu: bool,
  className: string,
  isLoading: bool,
};
